import { z } from "zod";

export const legalClientGroupSchema = z.object({
  idLegalClientGroup: z.number(),
  Name: z.string(),
  ColorHex: z.string(),
  Description: z.string().nullable(),
});

export type ILegalClientGroup = z.infer<typeof legalClientGroupSchema>;

export const createEmptyLegalClientGroup = (): ILegalClientGroup => ({
  idLegalClientGroup: -1,
  Name: "",
  ColorHex: "#000000",
  Description: null,
});
